<div class="checklist-wrap">
    <h1 class="text-center">Checklist</h1>
    <div>
        <div *ngFor="let check of checklist">
            
        </div>
    </div>
</div>